import React, { useEffect, useState } from "react";
import "./connect.scss";
import ItemTab from "../modules/ItemTabs";
import { Route, Routes } from "react-router-dom";
import FormIntro from "../FormIntro";
import Mentors from "./Mentors";
import Profile from "./Profile";
import { useNavigate } from "react-router-dom";
import Scholars from "../Scholars";
import Alumni from "../AlumniMentorScreen";
import { api } from "../../Services";
import { useSelector, useDispatch } from "react-redux";
import { addMentorInfo } from "./redux/actions";
import AlumniProfile from "../AlumniLoggedScreen/AlumniProfile";
import UserProfile from "../AlumniLoggedScreen/UserProfile";
import AlumniMentorProfile from "../AlumniMentorScreen/AlumniMentorProfile";

function Connect() {
  const navigate = useNavigate();
  const mentors = useSelector((state) => state.connect.mentors);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const [Link, setLink] = useState(
    window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "")
  );

  const navigateTo = (type) => {
    if (type === "Mentors") {
      navigate("/application/connect/mentors");
    } else if (type === "Alumni") {
      navigate("/application/connect/alumni");
    } else if (type === "Fellow Scholars") {
      navigate("/application/connect/scholars");
    }
  };
  useEffect(() => {
    let newCurrent = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    console.log("currentUrl2", newCurrent, newCurrent.split("/"));
    setLink(newCurrent);
  }, [window.location.href]);
  
  useEffect(() => {
    if (tokenData.applicationStatus !== "Awarded") {
      if (tokenData.applicationStatus === "Registered") {
        navigate("/application/status");
        // window.location.replace(url + "/application");
      } else {
        navigate("/application/submitted-status");
        // window.location.replace(url + "/application/submitted-status");
      }
    }
  }, []);
  console.log("in link", mentors);
  return (
    <div className="form-div connect-page">
      {!Link.split("/")[3] ||
      (Link.split("/")[3] &&
        Link.split("/")[3] !== "profile" &&
        Link.split("/")[3] !== "alumni-profile") ? (
        <>
          <div className="invite-text">
            <div className="form-title">Connect</div>
            <div className="form-desc">
              {tokenData.isAlumni
                ? "Welcome to our networking platform where you can explore a lineup of scholars to connect with, opportunities for knowledge sharing and upskilling."
                : "Welcome to our networking platform. Find a list of people to connect with ranging from Alumnis, to Fellow Scholars and IDFC FIRST Mentors"}
            </div>
          </div>
          <div className="tab-view">
            <ItemTab
              onChange={(e) => navigateTo(e)}
              list={["Mentors", "Alumni", "Fellow Scholars"]}
            />
          </div>
        </>
      ) : (
        <></>
      )}
      <Routes>
        <Route path="/" element={<Mentors />} />
        <Route path="/mentors/*" element={<Mentors />} />
        <Route path="/scholars/*" element={<Scholars />} />
        <Route path="/alumni/*" element={<Alumni />} />
        <Route path="alumni-profile" element={<AlumniMentorProfile />} />

        <Route path="/profile" element={<Profile />} />

        <Route path="*" element={<Mentors />} />
      </Routes>
    </div>
  );
}

export default Connect;
